'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCodeProps;
function getCodeProps(_ref) {
  var scales = _ref.scales;

  /**
   * Get the themed properties for a `Code` text component.
   * @param {string} appearance - default, minimal.
   * @return {string} the themd properties.
   */
  var getCodeProps = function getCodeProps(appearance) {
    switch (appearance) {
      case 'minimal':
        return {};
      case 'default':
      default:
        // Passing padding and border radius is non-ideal here.
        return {
          backgroundColor: scales.primary.P2A,
          boxShadow: 'inset 0 0 0 1px ' + scales.primary.P4A,
          paddingLeft: 6,
          paddingRight: 6,
          paddingTop: 3,
          paddingBottom: 3,
          borderRadius: 2
        };
    }
  };

  return getCodeProps;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2UvZ2V0Q29kZVByb3BzLmpzIl0sIm5hbWVzIjpbImdldENvZGVQcm9wcyIsInNjYWxlcyIsImFwcGVhcmFuY2UiLCJiYWNrZ3JvdW5kQ29sb3IiLCJwcmltYXJ5IiwiUDJBIiwiYm94U2hhZG93IiwiUDRBIiwicGFkZGluZ0xlZnQiLCJwYWRkaW5nUmlnaHQiLCJwYWRkaW5nVG9wIiwicGFkZGluZ0JvdHRvbSIsImJvcmRlclJhZGl1cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBQXdCQSxZO0FBQVQsU0FBU0EsWUFBVCxPQUFrQztBQUFBLE1BQVZDLE1BQVUsUUFBVkEsTUFBVTs7QUFDL0M7Ozs7O0FBS0EsTUFBTUQsZUFBZSxTQUFmQSxZQUFlLGFBQWM7QUFDakMsWUFBUUUsVUFBUjtBQUNFLFdBQUssU0FBTDtBQUNFLGVBQU8sRUFBUDtBQUNGLFdBQUssU0FBTDtBQUNBO0FBQ0U7QUFDQSxlQUFPO0FBQ0xDLDJCQUFpQkYsT0FBT0csT0FBUCxDQUFlQyxHQUQzQjtBQUVMQywwQ0FBOEJMLE9BQU9HLE9BQVAsQ0FBZUcsR0FGeEM7QUFHTEMsdUJBQWEsQ0FIUjtBQUlMQyx3QkFBYyxDQUpUO0FBS0xDLHNCQUFZLENBTFA7QUFNTEMseUJBQWUsQ0FOVjtBQU9MQyx3QkFBYztBQVBULFNBQVA7QUFOSjtBQWdCRCxHQWpCRDs7QUFtQkEsU0FBT1osWUFBUDtBQUNEIiwiZmlsZSI6ImdldENvZGVQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGdldENvZGVQcm9wcyh7IHNjYWxlcyB9KSB7XG4gIC8qKlxuICAgKiBHZXQgdGhlIHRoZW1lZCBwcm9wZXJ0aWVzIGZvciBhIGBDb2RlYCB0ZXh0IGNvbXBvbmVudC5cbiAgICogQHBhcmFtIHtzdHJpbmd9IGFwcGVhcmFuY2UgLSBkZWZhdWx0LCBtaW5pbWFsLlxuICAgKiBAcmV0dXJuIHtzdHJpbmd9IHRoZSB0aGVtZCBwcm9wZXJ0aWVzLlxuICAgKi9cbiAgY29uc3QgZ2V0Q29kZVByb3BzID0gYXBwZWFyYW5jZSA9PiB7XG4gICAgc3dpdGNoIChhcHBlYXJhbmNlKSB7XG4gICAgICBjYXNlICdtaW5pbWFsJzpcbiAgICAgICAgcmV0dXJuIHt9XG4gICAgICBjYXNlICdkZWZhdWx0JzpcbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIC8vIFBhc3NpbmcgcGFkZGluZyBhbmQgYm9yZGVyIHJhZGl1cyBpcyBub24taWRlYWwgaGVyZS5cbiAgICAgICAgcmV0dXJuIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kQ29sb3I6IHNjYWxlcy5wcmltYXJ5LlAyQSxcbiAgICAgICAgICBib3hTaGFkb3c6IGBpbnNldCAwIDAgMCAxcHggJHtzY2FsZXMucHJpbWFyeS5QNEF9YCxcbiAgICAgICAgICBwYWRkaW5nTGVmdDogNixcbiAgICAgICAgICBwYWRkaW5nUmlnaHQ6IDYsXG4gICAgICAgICAgcGFkZGluZ1RvcDogMyxcbiAgICAgICAgICBwYWRkaW5nQm90dG9tOiAzLFxuICAgICAgICAgIGJvcmRlclJhZGl1czogMlxuICAgICAgICB9XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIGdldENvZGVQcm9wc1xufVxuIl19